import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    failureCourseSubjects,
    successCourseSubjects,
} from "./CourseSubjectsSlice";

const CourseSubjectsApi = (action: PayloadAction<any>) => {
    return api.get("/api/course/subjects", {
        params: action.payload,
    });
};

export function* CourseSubjectsCall(action: PayloadAction<any>) {
    try {
        const response: AxiosResponse = yield call(CourseSubjectsApi, action);
        yield put(successCourseSubjects(response.data));
    } catch (error) {
        yield put(failureCourseSubjects(error));
    }
}
